import { render } from "./InstagramLooks.vue?vue&type=template&id=11fdecc7&scoped=true"
import script from "./InstagramLooks.vue?vue&type=script&lang=js"
export * from "./InstagramLooks.vue?vue&type=script&lang=js"

import "./InstagramLooks.vue?vue&type=style&index=0&id=11fdecc7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fdecc7"]])

export default __exports__